import type { Appliance } from '../../types/electricity'
import { useLanguage } from '../../i18n/LanguageContext'

interface Props {
  appliance: Appliance
  selected: boolean
  onSelect: (a: Appliance) => void
}

export function ApplianceCard({ appliance, selected, onSelect }: Props) {
  const { t } = useLanguage()
  const name = t(`appliances.${appliance.id}` as 'appliances.ac') as string

  return (
    <button
      onClick={() => onSelect(appliance)}
      className={`appliance-card ${selected ? 'selected' : ''} flex flex-col items-center gap-2 text-center`}
    >
      <span className="text-3xl">{appliance.emoji}</span>
      <span className="text-xs text-slate-300 font-body leading-tight">{name}</span>
    </button>
  )
}
